import { cn } from "@/lib/utils";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "animate-pulse rounded-md bg-skeleton-background",
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
